import {requestUser} from '@/utils/request'
import {getDataToken} from "@/utils/auth"

// 编辑用户名
export function platformUserUpdateNickname(data) {
  return requestUser({
    url: '/platformUser/updateNickname',
    method: 'post',
    data
  })
}
// 获取验证码
export function getCodeImg() {
  return requestUser({
    url: '/captcha/image',
    method: 'post',
  })
}

// 邮箱密码登录
export function emailPasswordLogin(data) {
  return requestUser({
    url: '/platformUser/emailPasswordLogin',
    method: 'post',
    data
  })
}
// 手机验证码登录
export function phoneCaptchaLogin(data) {
  return requestUser({
    url: '/platformUser/phoneCaptchaLogin',
    method: 'post',
    data
  })
}
// 密码登录
export function login(data) {
  return requestUser({
    url: '/platformUser/phoneEmailPasswordLogin',
    method: 'post',
    data
  })
}

// 手机号
export function loginByPhoneCode(data) {
  return requestUser({
    url: '/platformUser/phoneEmailCaptchaLogin',
    method: 'post',
    data
  });
}

// 获取用户信息
export function getInfo() {
  return requestUser({
    url: '/platformUser/info',
    method: 'post',
    data: {
      token:getDataToken()
    }
  })
}

// 登出
export function logout() {
  return requestUser({
    url: '/platformUser/logout',
    method: 'post',
    data: {
      token:getDataToken()
    }
  })
}

// 用户列表
export function getAllUsers(data) {
  return requestUser({
    url: '/user/list',
    method: 'post',
    data
  })
}
// 货主用户列表 分页
export function sellerPage(data) {
  return requestUser({
    url: '/seller/page',
    method: 'post',
    data
  })
}
// 平台用户列表 分页
export function fetchList(data) {
  return requestUser({
    url: '/platformUser/page',
    method: 'post',
    data
  })
}
// 获取客服
export function platformUserSelectList(data) {
  return requestUser({
    url: '/platformUser/selectList',
    method: 'post',
    data
  })
}
// 商城用户列表
export function buyerPage(data) {
  return requestUser({
    url: '/buyer/page',
    method: 'post',
    data
  })
}

// 新增
export function addUser(data) {
  return requestUser({
    url: '/platformUser/save',
    method: 'post',
    data
  })
}

// 修改用户
export function updateAdmin(data) {
  return requestUser({
    url: '/platformUser/update',
    method: 'post',
    data
  })
}

// 修改用户状态
export function updateStatus(data) {
  return requestUser({
    url: '/user/updateStatus',
    method: 'post',
    data
  })
}

//修改用户状态： 买家
export function buyerUpdateStatus(data) {
  return requestUser({
    url: '/buyer/updateStatus',
    method: 'post',
    data
  })
}
//修改用户状态： 平台
export function platformUserUpdateStatus(data) {
  return requestUser({
    url: '/platformUser/updateStatus',
    method: 'post',
    data
  })
}

// 删除
export function deleteAdmin(data) {
  return requestUser({
    url: `/platformUser/delete`,
    method: 'post',
    data
  })
}

// 根据Id查询
export function getAdminById(data) {
  return requestUser({
    url: '/platformUser/selectOne',
    method: 'post',
    data
  })
}

// 重置密码
export function resetPassword(data) {
  return requestUser({
    url: '/user/resetPassword',
    method: 'post',
    data
  })
}
// 管理员重置密码
export function platformUserResetPassword(data) {
  return requestUser({
    url: '/platformUser/resetPassword ',
    method: 'post',
    data
  })
}
// 重置密码: 平台
export function platformUserCheckCodeAndResetPassword(data) {
  return requestUser({
    url: '/platformUser/checkCodeAndResetPassword',
    method: 'post',
    data
  })
}

/**
 *     "id": "",
 *     "username": "",
 *     "email": "",
 *     "phoneAreaCode": "",
 *     "phoneCountryCode": "",
 *     "phone": ""
 * @param data
 * @returns {response}
 * 校验是否唯一
 */
export function checkUnique(data) {
  return requestUser({
    url: '/platformUser/checkUnique',
    method: 'post',
    data
  })
}

// 获取手机验证码
export function sendPhoneCode(data) {
  return requestUser({
    url: `/captcha/sendPhoneCode`,
    method: 'post',
    data
  })
}

// 获取邮箱验证码
export function sendEmailCode(data) {
  return requestUser({
    url: `/captcha/sendEmailCode`,
    method: 'post',
    data
  })
}

// 找回密码
export function resetPass(data) {
  return requestUser({
    url: `/user/checkCodeAndResetPassword`,
    method: 'post',
    data
  })
}





// WEBPACK FOOTER //
// ./src/api/login.js